import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GlowCard } from "@/components/ui/spotlight-card";
import { ShineBorder } from "@/components/ui/shine-border";
import { clickCta } from "@/lib/analytics";

interface ReadyToGrowSectionProps {
  onCtaClick?: () => void;
}

export function ReadyToGrowSection({ onCtaClick }: ReadyToGrowSectionProps = {}) {
  return (
    <section className="relative isolate overflow-hidden bg-background pt-0 pb-2 sm:pt-0 sm:pb-3">
      <div className="mx-auto max-w-6xl px-4 py-1 sm:px-6 sm:py-2">
        <ShineBorder
          borderRadius={16}
          borderWidth={2}
          duration={10}
          color={["#3b82f6", "#a855f7", "#ec4899"]}
        >
          <GlowCard glowColor="blue" disableInnerGlow customSize className="relative w-full">
            <div className="relative flex flex-col items-center gap-4 px-3 py-6 text-center sm:px-14 sm:py-10">
              <h3 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-5xl">
                Ready to{" "}
                <span className="text-gradient-cycle">grow your brand?</span>
              </h3>
              <p className="max-w-4xl text-pretty text-base text-muted-foreground sm:text-lg">
                You work directly with us on a simple monthly plan, and get a premium
                <br className="hidden sm:block" />
                site without the agency markup, the months of waiting, or the giant upfront bill.
              </p>
              <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    clickCta("Get a Free Mockup", "ready_to_grow_section");
                    onCtaClick?.();
                  }}
                  className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand-blue to-[#ec4899] px-6 py-3 text-sm font-semibold text-white transition-all hover:opacity-90 active:scale-[0.98]"
                >
                  Get a Free Mockup
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </button>
                <Button
                  asChild
                  variant="outline"
                  className="h-12 px-8 rounded-full border-brand-blue text-brand-blue hover:bg-brand-blue/10 font-semibold"
                >
                  <a href="#pricing" onClick={() => clickCta("See Pricing", "ready_to_grow_section")}>See Pricing</a>
                </Button>
              </div>
            </div>
          </GlowCard>
        </ShineBorder>
      </div>
    </section>
  );
}
